<template>
    <Transition
        enter-active-class="transition-opacity duration-200 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity duration-150 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            v-if="open"
            class="mobile-menu-backdrop xl:!hidden h-[calc(100vh-44px)] overflow-y-auto"
            @click.self="closeMenu"
        >
            <div class="mobile-menu-panel">
                <nav class="mobile-menu-items">
                    <div class="mobile-menu-group">
                        <button
                            type="button"
                            class="mobile-menu-item mobile-menu-item--accordion"
                            @click="toggleMobileSection('video')"
                        >
                            <span>{{ t('menus.videoAI') }}</span>
                            <svg
                                class="mobile-menu-chevron"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                :class="{ 'rotate-180': isMobileVideoOpen }"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M19 9l-7 7-7-7"
                                />
                            </svg>
                        </button>
                        <div v-if="isMobileVideoOpen" class="mobile-submenu">
                            <NuxtLink
                                to="/image-to-video"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('imageToVideoAI') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/text-to-video"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('textToVideoAI') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/video-to-video"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('aiVideoEditor') }}
                            </NuxtLink>
                        </div>
                    </div>

                    <!-- 图片 AI 折叠组 -->
                    <div class="mobile-menu-group">
                        <button
                            type="button"
                            class="mobile-menu-item mobile-menu-item--accordion"
                            @click="toggleMobileSection('image')"
                        >
                            <span>{{ t('menus.imageAI') }}</span>
                            <svg
                                class="mobile-menu-chevron"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                :class="{ 'rotate-180': isMobileImageOpen }"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M19 9l-7 7-7-7"
                                />
                            </svg>
                        </button>
                        <div v-if="isMobileImageOpen" class="mobile-submenu">
                            <NuxtLink
                                to="/text-to-image"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('aiImageGenerator') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/image-to-image"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('imageToImageAI') }}
                            </NuxtLink>
                        </div>
                    </div>

                    <!-- 编辑工具 折叠组（顺序和 PC 顶部菜单一致） -->
                    <div class="mobile-menu-group">
                        <button
                            type="button"
                            class="mobile-menu-item mobile-menu-item--accordion"
                            @click="toggleMobileSection('tools')"
                        >
                            <span>{{ t('menus.aiTools') }}</span>
                            <svg
                                class="mobile-menu-chevron"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                :class="{ 'rotate-180': isMobileToolsOpen }"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M19 9l-7 7-7-7"
                                />
                            </svg>
                        </button>
                        <div v-if="isMobileToolsOpen" class="mobile-submenu">
                            <!-- 视频工具 -->
                            <NuxtLink
                                to="/remove-video-watermark"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('aiWatermarkRemoval') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/video-lip-sync"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('aiVideoLipSync') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/translate-video-subtitle"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('tools.videoSubtitleTranslateTitle') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/video-to-anime"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('tools.videoToAnimeTitle') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/video-upscaler"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('tools.videoUpscalerTitle') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/remove-video-subtitles"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('footer.aiVideoSubtitleErase') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/video-background-remover"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{
                                    t('tools.videoBackgroundRemoverShortTitle')
                                }}
                            </NuxtLink>
                            <NuxtLink
                                to="/ai-video-extender"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('tools.videoExtenderTitle') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/video-motion-imitation"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('tools.videoMotionImitationTitle') }}
                            </NuxtLink>
                            <!-- 图片工具 -->
                            <NuxtLink
                                to="/ai-image-resizer"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('footer.aiImageAspectRatioConverter') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/image-text-translate"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('aiImageTranslation') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/ai-background-changer"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('footer.aiBackgroundChanger') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/image-upscaler"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('footer.aiImageUpscaler') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/photo-face-swap"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('tools.photoFaceSwapTitle') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/remove-text-from-image"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('tools.removeTextFromImage') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/photo-restoration"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('tools.photoRestorationTitle') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/ai-image-background-remover"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('img_bg_remove.pageTitle') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/ai-image-extender"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('img_extender.title') }}
                            </NuxtLink>
                        </div>
                    </div>

                    <!-- 特效 折叠组 -->
                    <div class="mobile-menu-group">
                        <button
                            type="button"
                            class="mobile-menu-item mobile-menu-item--accordion"
                            @click="toggleMobileSection('effects')"
                        >
                            <span>{{ t('menus.effects') }}</span>
                            <svg
                                class="mobile-menu-chevron"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                :class="{
                                    'rotate-180': isMobileEffectsOpen,
                                }"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M19 9l-7 7-7-7"
                                />
                            </svg>
                        </button>
                        <div v-if="isMobileEffectsOpen" class="mobile-submenu">
                            <NuxtLink
                                to="/video-effects"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('menus.videoEffects') }}
                            </NuxtLink>
                            <NuxtLink
                                to="/photo-effects"
                                class="mobile-submenu-item"
                                @click="closeMenu"
                            >
                                {{ t('menus.photoEffects') }}
                            </NuxtLink>
                        </div>
                    </div>

                    <!-- 定价 -->
                    <NuxtLink
                        to="/pricing"
                        class="mobile-menu-item"
                        @click="closeMenu"
                    >
                        <span>{{ t('menus.pricingLink') }}</span>
                    </NuxtLink>
                </nav>
            </div>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from '@/composables/useI18n'

defineProps<{
    open: boolean
}>()

const emit = defineEmits<{
    (e: 'update:open', value: boolean): void
}>()

const { t } = useI18n()

const isMobileVideoOpen = ref(false)
const isMobileImageOpen = ref(false)
const isMobileToolsOpen = ref(false)
const isMobileEffectsOpen = ref(false)

const closeMenu = () => {
    emit('update:open', false)
    // 关闭时顺便收起所有二级菜单
    isMobileVideoOpen.value = false
    isMobileImageOpen.value = false
    isMobileToolsOpen.value = false
    isMobileEffectsOpen.value = false
}

const toggleMobileSection = (
    section: 'video' | 'image' | 'tools' | 'effects'
) => {
    if (section === 'video') {
        isMobileVideoOpen.value = !isMobileVideoOpen.value
    } else if (section === 'image') {
        isMobileImageOpen.value = !isMobileImageOpen.value
    } else if (section === 'tools') {
        isMobileToolsOpen.value = !isMobileToolsOpen.value
    } else if (section === 'effects') {
        isMobileEffectsOpen.value = !isMobileEffectsOpen.value
    }
}
</script>

<style lang="less" scoped>
.mobile-menu-backdrop {
    position: fixed;
    inset: 52px 0 0 0;
    background-color: #0d0e12;
    z-index: 39;
    display: block;
}

.mobile-menu-panel {
    width: 100%;
    max-width: 100%;
    background: #0d0e12;
    padding: 0 0 24px;
    box-shadow: none;
}

.mobile-menu-items {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.mobile-menu-item {
    display: block;
    padding: 14px 20px;
    color: #f9fafb;
    font-size: 15px;
    text-decoration: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    transition:
        color 0.2s ease,
        background-color 0.2s ease;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        color: var(--weryai-text-active);
        background-color: rgba(255, 255, 255, 0.03);
        text-decoration: none;
    }
}

.mobile-menu-group {
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.mobile-menu-item--accordion {
    width: 100%;
    text-align: left;
    background: transparent;
    border: none;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.mobile-menu-chevron {
    width: 16px;
    height: 16px;
    transition: transform 0.2s ease;
}

.mobile-submenu {
    background-color: #0d0e12;
}

.mobile-submenu-item {
    display: block;
    padding: 10px 36px;
    font-size: 14px;
    color: rgba(249, 250, 251, 0.9);
    text-decoration: none;
    border-top: 1px solid rgba(255, 255, 255, 0.04);
    transition:
        color 0.2s ease,
        background-color 0.2s ease;

    &:hover {
        color: var(--weryai-text-active);
        background-color: rgba(255, 255, 255, 0.03);
        text-decoration: none;
    }
}
</style>
